import FrontPage from '../../Layout/FrontPage'
import Home from "../pages/Front/Home";

export default {
    path: '/',
    component: FrontPage,
    // redirect: '/home',
    children: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta:{
                title:'Home'
            },
        },
    ]
}
